import { DiscountCodeDetailPage } from '@/pages/DiscountCodeDetailPage'
import { DiscountCodesPage } from '@/pages/DiscountCodesPage'

export type DiscountCodeSettingsViewState =
  | { kind: 'discount-codes' }
  | { kind: 'discount-code-detail'; discountCodeId: number }

export function DiscountCodeSettingsView({
  view,
  navigateTo,
}: {
  view: DiscountCodeSettingsViewState
  navigateTo: (view: DiscountCodeSettingsViewState, path: string) => void
}) {
  if (view.kind === 'discount-code-detail') {
    return (
      <DiscountCodeDetailPage
        discountCodeId={view.discountCodeId}
        onBack={() => navigateTo({ kind: 'discount-codes' }, '/settings/discount-codes')}
      />
    )
  }

  return (
    <DiscountCodesPage
      onOpen={(code) =>
        navigateTo(
          { kind: 'discount-code-detail', discountCodeId: code.id },
          `/settings/discount-codes/${code.id}`,
        )
      }
    />
  )
}
